import {getOutlet} from 'reconnect.js';
import * as tw from './tw';
import * as en from './en';

const LocaleOutlet = getOutlet('locale');
const Dictionaries = {
  tw,
  en,
};

function getLabel(key, defaultValue) {
  let value = null;
  try {
    value = Dictionaries[LocaleOutlet.getValue().lang].labels[key];
  } catch (ex) {
    // pass
  }

  if (value) {
    return value;
  } else if (defaultValue) {
    return defaultValue;
  }
  return key;
}

function getField(obj, field, locale) {
  if (!obj) {
    return '';
  }

  if (!locale) {
    locale = getOutlet('locale').getValue();
  }

  return obj[`${field}_${locale.lang}`] || obj[field];
}

function getUserDefined(dictionary, defaultValue) {
  /* dictionary like
  {
    tw: '蘋果',
    en: 'apple'
  }
  */
  if (!dictionary) {
    return defaultValue || '';
  }
  const locale = getOutlet('locale').getValue();

  return dictionary[locale.lang] || defaultValue;
}

export {getLabel, getField, getUserDefined};
